<template>
  <div style="background-color: #efefef">
    <div class="soluRightBtn">
      <span style="color: #808080">当前位置：</span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/association' }"
        >水泵协会</el-breadcrumb-item
        >
        <el-breadcrumb-item>协会简报</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="soluBottom">
      <div class="suluBottomBig" v-if="!showNoNews">
        <div
            class="soluBottomRList"
            v-for="(items, index) in solutionList"
            :key="index"
            @click="getNewsItemDetail(items.uuid)"
        >
          <div class="soluBottomRImg">
            <img :src="items.thumbnailPath" alt="" />
            <p>{{ items.name }}</p>
          </div>
        </div>
      </div>
      <div v-if="showNoNews" class="suluBottomBig2">
        <!-- 暂无数据 -->
        <img src="../../../assets/noMesge.jpg" style="width: 200px" />
      </div>
      <!-- 分页 -->
      <div class="pageina" v-if="!showNoNews">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="current"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// 协会会员列表
import {briefProTable} from "../../../utils/associationApi";
export default {
  //   新闻
  name: "briefList",
  metaInfo: {
    title: "水泵云--水泵协会协会简报", // set a title
  },
  components: {},
  data() {
    return {
      showNoNews: false,
      imgHeightsetIn: null,
      solutionList: [],
      // 分页
      current: 1,
      pageSize: 25,
      total: 0,
      programUuid: "",
      title: "",
      timer: null,
      setIn: null, // 定时器
    };
  },
  created() {
    this.getBriefList();
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getSolutionList();
    },
    handleCurrentChange(val) {
      this.current = val;
      window.scrollTo(0, 0);
      this.getSolutionList();
    },
    getBriefList() {
      let params = {
        status: 1,
        publishDate: '',
        current: this.current,
        pageSize: this.pageSize,
      };
      briefProTable(params).then((res) => {

          this.solutionList = res.list;
          this.total = res.total;
          if (this.total > 0) {
            this.showNoNews = false;
          } else {
            this.showNoNews = true;
          }

      });
    },
    getNewsItemDetail(uuid) {
      let routeData = this.$router.resolve({
        name: "briefInfo",
        params: {
          uuid: uuid,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped lang="less">
.soluRightBtn {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  font-size: 14px;
  color: #6e6e6e;
  display: flex;
  align-items: center;
  font-weight: 400;
}
.soluBottom {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 40px;

  .suluBottomBig2 {
    text-align: center;
  }
  .suluBottomBig {
    padding-top: 15px;
    display: grid;
    grid-template-columns: 227px 227px 227px 227px 227px;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    .soluBottomRList {
      cursor: pointer;

      .soluBottomRImg {
        width: 210px;
        height: 270px;
        margin-right: 40px;
        flex-shrink: 0;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
        p {
          position: absolute;
          bottom: 0;
          background-color: #099;
          font-size: 12px;
          color: #fff;
          width: 100%;
          padding: 3px;
          box-sizing: border-box;
          text-align: center;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
        }
      }
    }
  }
  .pageina {
    margin-top: 74px;
    text-align: center;
    margin-right: 20px;
    /deep/.el-pagination button:disabled {
      background-color: transparent;
      border: 1px solid #efefef;
      border-radius: 5px;
    }
    /deep/.el-pagination .btn-prev {
      padding-right: 0;
    }
    /deep/.el-pager li {
      border: 1px solid #efefef;
      border-radius: 5px;
      margin: 0 5px;
    }
    /deep/.el-pager li.active {
      border: 1px solid #009999;
      color: #009999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/association/components/briefList.vue